import { render } from "./MainHeaderUserButton.vue?vue&type=template&id=6b0de972&scoped=true"
import script from "./MainHeaderUserButton.vue?vue&type=script&lang=js"
export * from "./MainHeaderUserButton.vue?vue&type=script&lang=js"

import "./MainHeaderUserButton.vue?vue&type=style&index=0&id=6b0de972&scoped=true&lang=scss"
import "./MainHeaderUserButton.vue?vue&type=style&index=1&id=6b0de972&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0de972"]])

export default __exports__